import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "json-field-editor" }
const _hoisted_2 = ["id", "name", "value", "rows"]
const _hoisted_3 = { class: "json-field-actions" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("textarea", {
      id: $props.inputId,
      name: $props.inputName,
      value: $props.modelValue,
      class: "form-control json-field",
      rows: $props.rows,
      onInput: $setup.updateValue
    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-sm btn-secondary",
        onClick: $setup.formatValue
      }, " Format JSON "),
      _createElementVNode("span", {
        class: _normalizeClass(["json-status", {
          'json-status-valid': $setup.validation.valid && !$setup.validation.empty,
          'json-status-empty': $setup.validation.empty,
          'json-status-invalid': !$setup.validation.valid,
        }])
      }, _toDisplayString($setup.validation.valid ? `✓ ${$setup.validation.message}` : `✗ ${$setup.validation.message}`), 3 /* TEXT, CLASS */)
    ])
  ]))
}